import React, {useEffect, useRef} from 'react';
import SarasTrans from '../../../library/notifications/SarasTrans'
import SarasNavigation from '../../../library/navigate/SarasNavigation';
import Icon from '../../../library/decor/SarasIcons';
import {getPublicMenuImg} from '../../../helper/uiFunctions';

const AppMenuRow = ({menuRow, onMenuSelect, scrollToMenuRow}) => {
  const rowRef = useRef();

  useEffect(() => {
    if (
      scrollToMenuRow &&
      menuRow.MenuTitle === scrollToMenuRow.MenuTitle &&
      rowRef.current
    ) {
      rowRef.current.scrollIntoView({ block: 'nearest' });
    }
  }, [scrollToMenuRow, menuRow.MenuTitle]);

  const renderGridMenuRow = (childRow, index) => {
    if (!childRow.MenuTitle)
      return (null)
  
    return (
      <li key={index}>
        <SarasNavigation menu={childRow} toN={childRow.MenuLink} onSelect={onMenuSelect}>
          <img alt="" src={getPublicMenuImg(childRow.MenuIcon)} />
          <span className='uiMenuTitle'><SarasTrans value={childRow.MenuTitle} /></span>
        </SarasNavigation>
      </li>
    )
  }

  var MIcon = null;

  if(menuRow.MenuIcon.length>0 )
    MIcon = Icon[menuRow.MenuIcon];

    return (
      <>
          <div className='uiMenuGroup' ref={rowRef}>
            <span className='uiMenuGroupTitle'>
              {MIcon ? <MIcon className='uiMenuIcon' /> : null}
              <SarasTrans value={menuRow.MenuTitle} /></span>
            <ul>

            {menuRow.MenuType === 'f' ? menuRow.ChildMenus
                .sort((a, b) => b.UseCount - a.UseCount)
                .slice(0, 5)
                .map((childRow, index) => (
                  renderGridMenuRow(childRow, index)
            )) : null}

              {menuRow.MenuType !== 's' && menuRow.MenuType !== 'f' ? menuRow.ChildMenus.map((childRow, index) => (
                  renderGridMenuRow(childRow, index)
              )) : null}
            </ul>
          </div>
      </>
    );
};

export default AppMenuRow;
